module.exports = __webpack_public_path__ + "static/media/avatar5.6b6dfce0.jpg";